/**
 * A Decal node in the scene graph, which its scene's decals find and draw (`sceneDecals.ts`). It
 * carries its node's world transform, the properties it draws with, its textures and its place in
 * the tree. Its size scales nothing: the box is a property, not a transform.
 */
import * as THREE from 'three';
import { decalAtlasRect } from '../../nodes/3d/decal/decalAtlas.js';
export class DecalObject extends THREE.Object3D {
    isDecal = true;
    /** Set by the decal's component before the scene's decals first read it. */
    look;
    /** The texture of each map that the decal atlas holds for this decal, null while none loaded. */
    textures = {
        albedo: null,
        normal: null,
        orm: null,
        emission: null,
    };
    /** Set by the decal's component. Decals at one distance draw in it, and the mount order differs. */
    treeOrder;
    mapRect(map) {
        const texture = this.textures[map];
        return (texture && decalAtlasRect(texture)) ?? null;
    }
}
export function isDecal(object) {
    return object.isDecal === true;
}
//# sourceMappingURL=decalObject.js.map